<template>
  <router-view />
  <RedirectModal />
  <DevTools v-if="showDevTools" />
</template>

<script setup>
import { computed } from 'vue'

/*************** */
/* Dark mode     */
/*************** */
import { useDarkMode } from '@/composables/useDarkMode'
import RedirectModal from '@/components/RedirectModal.vue'
import DevTools from '@/views/Dev/DevTools.vue'
import { useConnectedUserStore } from '@/stores/connectedUser'

const { initDarkMode } = useDarkMode()

initDarkMode()

const userConnected = useConnectedUserStore()
const showDevTools = computed(() => ['develop', 'uat', 'preprod', 'staging'].includes(import.meta.env.MODE) && !!userConnected?.role)
</script>
